import { FeaturedImageFragment } from '@/fragments/FeaturedImage'
import { FlexibleContentFragment } from '@/fragments/FlexibleContent'
import { GravityFormsFragment } from '@/fragments/GravityForms'
import { PostsFragment } from '@/fragments/Posts'
import { gql } from '@apollo/client'

export const variables = ({ databaseId }, ctx) => {
  return {
    databaseId,
    asPreview: ctx?.asPreview
  }
}

export const query = gql`
  ${FeaturedImageFragment}
  ${FlexibleContentFragment}
  ${GravityFormsFragment}
  ${PostsFragment}
  query GetPageData($databaseId: ID!, $asPreview: Boolean = false) {
    page(id: $databaseId, idType: DATABASE_ID, asPreview: $asPreview) {
      title
      seo {
        metaDesc
        title
      }
      ...FeaturedImageFragment
      ...FlexibleContentFragment
      innerHeroFields {
        content
        eyebrowText
        fieldGroupName
        includeForm
        title
      }
    }
    posts(first: 12) {
      nodes {
        ...PostsFeedItemFragment
      }
    }
    careersForm: gfForm(id: 3, idType: DATABASE_ID) {
      ...GravityFormsFragment
    }
    headerForm: gfForm(id: 2, idType: DATABASE_ID) {
      ...GravityFormsFragment
    }
  }
`
